import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UtilityService } from '@common/services';
import { LayoutSidenav } from '@modules/navigation/classes';
import {
    sideNavItems,
    sideNavSections,
} from '@modules/navigation/data/side-nav-leaseManagement.data';
// import { sideNavItems, sideNavSections } from '@modules/navigation/data/side-nav-dashboard.data';
import { NavigationService } from '@modules/navigation/services';

@Component({
    selector: 'cwr-layout-lease-management',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './layout-lease-management.component.html',
    styleUrls: ['layout-lease-management.component.scss'],
})
export class LayoutLeaseManagementComponent extends LayoutSidenav implements OnInit {
    sideNavItems = sideNavItems;
    sideNavSections = sideNavSections;

    constructor(
        public utilityService: UtilityService,
        public navigationService: NavigationService,
        public changeDetectorRef: ChangeDetectorRef
    ) {
        super(utilityService, navigationService, changeDetectorRef);
    }
    ngOnInit() {
        super.ngOnInit();
    }
}
